import { defineMessages } from 'react-intl';

export const giftCardsScreenCategoriesGridMessages = defineMessages({
  gridItemA11yLabel: {
    defaultMessage: 'Select "{gift_card}" gift card',
    description: 'Gift Cards | Grid item accessibility label',
  },
});
